import axios from 'axios'
// URL de la API
const baseURL = process.env.VUE_APP_BASE_URL_API

// Objeto axios de la api de Retencion
const apiRetencion = axios.create({
  baseURL: baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  //timeout: 10000, // 10 segundos de espera
})

export default {
  /**
   * @name getRetencion
   * @description Obtienen una lista de Retencions
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} params campo1 -> Parametros para poblar el Select
   */
  getRetencion(jwt, params) {
    apiRetencion.defaults.headers.common['Authorization'] = 'Bearer ' + jwt

    if (params != null) {
      return apiRetencion.get('retencion/' + params)
    }
    return apiRetencion.get('retencion/')
  },

  /**
   * @name postRetencion
   * @description Se crea el Retencion
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} params campo1 -> Parametros para poblar el Select
   */
  postRetencion(jwt, body) {
    apiRetencion.defaults.headers.common['Authorization'] = 'Bearer ' + jwt
    return apiRetencion.post('retencion/', body)
  },

  /**
   * @name putRetencion
   * @description Se actualiza el Retencion
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} params campo1 -> Parametros para poblar el Select
   */
  putRetencion(jwt, body, id) {
    apiRetencion.defaults.headers.common['Authorization'] = 'Bearer ' + jwt
    return apiRetencion.put('retencion/' + id, body)
  },
  /**
   * @name deleteRetencion
   * @description Se actualiza el Retencion
   *
   * @param {*} jwt JSON Web Token válido
   * @param {*} params campo1 -> Parametros para poblar el Select
   */
  deleteRetencion(jwt, body, id) {
    apiRetencion.defaults.headers.common['Authorization'] = 'Bearer ' + jwt
    return apiRetencion.delete('retencion/' + id, body)
  },
}
